<template>
	<div class="inspection">
		<div class="nav">
			<div class="nav-left">
				<div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toOxygenSensor">
					<div>氧气传感器</div>
				</div>
				<div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toCarbonDioxideSensor">
					<div>二氧化碳传感器</div>
				</div>
				<div class="parallelogram-btn-left" @click="toTemperatureAndHumiditySensor">
					<div>温湿度传感器</div>
				</div>
			</div>
			<div class="nav-center">数据报表</div>
			<div class="nav-right">
				<div class="parallelogram-btn-right" style="margin-right: 0.5vw" @click="toTemperatureSensor">
					<div>包芯温度传感器</div>
				</div>
				<div class="parallelogram-btn-right  parallelogram-btn-active" style="margin-right: 0.5vw">
					<div>包芯水分传感器</div>
				</div>
				<div class="parallelogram-btn-right" @click="toTypeStatistics">
					<div>在垛传感器数量</div>
				</div>
			</div>
		</div>
		<div class="report-select">
			<div class="report-select-top">
				<div style="margin-right: 0.7vw">
					<DropDown :content="warehouseTitle" :items="warehouse" @sendInfo="showInfoW"></DropDown>
				</div>
				<div style="margin-right: 0.7vw">
					<DropDown message="请选择仓库" :content="buildingTitle" :items="building" @sendInfo="showInfoB">
					</DropDown>
				</div>
				<div style="margin-right: 0.7vw">
					<DropDown message="请选择楼号" :content="floorTitle" :items="floor" @sendInfo="showInfoF"></DropDown>
				</div>
				<div style="margin-right: 0.7vw">
					<DropDown message="请选择层号" :content="areaTitle" :items="area" @sendInfo="showInfoA"></DropDown>
				</div>
				<div style="margin-right: 0.7vw">
					<DropDown message="请选择垛位" :content="stackTitle" :items="stack" @sendInfo="showInfoS"></DropDown>
				</div>
				<div style="margin-right: 0.7vw">
					<DropDown :content="maintainStageName" :items="maintainStageData" v-on:sendInfo="showInfoMaintainStag">
					</DropDown>
				</div>

			</div>
			<div class="report-select-bottom">
				<div class="report-select-left">
					<div class="six-font-wrapper">
						<div class="icon-font">&#xe601;</div>导出数据报表
						<button readonly="readonly"
							style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0"
							@click="downloadDatarReport" />
					</div>
					<div class="input-wrapper"><input disabled="true" v-model="contrast1" placeholder="" /><i
							class="el-icon-circle-close" @click="delContrast(0)" v-show="contrast1show" /></div>
					<div class="input-wrapper"><input disabled="true" v-model="contrast2" placeholder="" /><i
							class="el-icon-circle-close" @click="delContrast(1)" v-show="contrast2show" /></div>
					<div class="four-font-wrapper" style="margin-left: 0.4vw">数据对比
						<button slot="reference" readonly="readonly"
							style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0"
							@click="contrastShow" />
					</div>
				</div>
				<div class="report-select-right">
					<div class="input-date-wrapper-switch">
						<span>是否选择仓间:</span>
						<el-switch v-model="storehouseFlag" inactive-color="#747d8c">
						</el-switch>
					</div>
					<div class="input-date-wrapper">
						<el-date-picker v-model="time" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
					<div class="query button" @click="handleSearch()">查询</div>
				</div>
			</div>
		</div>
		<div class="task-content">
			<div class="detail">
				<div class="detail-box">
					<div class="loading-data" v-if="loading" style="margin-top: 15vh">
						<i class="el-icon-loading"></i>
						<div>加载中，请稍后···</div>
					</div>
					<div class="detail-nav">
						<div class="detail-item" style="width: 3%">
							<div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
						</div>
						<div class="detail-item" style="width: 10%">垛位号</div>
						<div class="detail-item" style="width: 12%">坐标</div>
						<div class="detail-item" style="width: 8%">烟叶代码</div>
						<div class="detail-item" style="width: 10%">烟叶名称</div>
						<div class="detail-item" style="width: 10%">养护阶段</div>
						<div class="detail-item" style="width: 7%">当前湿度</div>
						<div class="detail-item" style="width: 7%">最大湿度</div>
						<div class="detail-item" style="width: 7%">最小湿度</div>
						<div class="detail-item" style="width: 7%">平均湿度</div>
						<div class="detail-item" style="width: 14%">时间</div>
						<div class="detail-item" style="width: 5%">操作</div>
					</div>
					<div class="detail-content" v-if="!loading">
						<div class="detail-list-wrapper" v-if="!loading && tableData.length>0"
							v-for="(data,index) in tableData" :key="index">
							<div class="detail-item" style="width: 3%">
								<div class="select-icon" :class="{'select-icon-active': data.sign === 1}"
									@click="selectSingle(data)"></div>
							</div>
							<div class="detail-item" style="width: 10%">{{data.stack? data.stack : '--'}}</div>
							<div class="detail-item" style="width: 12%">X:{{ data.x || "--" }} Y:{{ data.y || "--" }} Z:{{ data.z || "--" }}</div>
							<div class="detail-item" style="width: 8%">
								<el-popover placement="top" title="" trigger="hover" :content="data.materialCode">
									<div class="popover" style="width: 8vw;text-align: center" slot="reference">
										{{data.materialCode? data.materialCode : '--'}}</div>
								</el-popover>
							</div>
							<div class="detail-item" style="width: 10%">
								<el-popover placement="top" title="" trigger="hover" :content="data.materialName">
									<div class="popover" style="width: 8vw;text-align: center" slot="reference">
										{{data.materialName? data.materialName : '--'}}</div>
								</el-popover>
							</div>
							<div class="detail-item" style="width: 10%">
								{{data.maintainStage? data.maintainStage.name : '--'}}</div>
							<div class="detail-item" style="width: 7%">{{data.val || '--'}}</div>
							<div class="detail-item" style="width: 7%">{{data.maxVal || '--'}}</div>
							<div class="detail-item" style="width: 7%">{{data.minVal || '--'}}</div>
							<div class="detail-item" style="width: 7%">{{data.avgVal || '--'}}</div>
							<div class="detail-item" style="width: 14%">{{getTime(data.createdTime)}}</div>
							<div class="detail-item" style="width: 5%">
								<div class="detail-btn  item-audit" @click="addContrast(data)" v-if="data.grey === 0">选择
								</div>
								<div class="detail-btn  item-audit item-audit-active" v-if="data.grey === 1">选择</div>
							</div>
						</div>
						<div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
					</div>
					<div class="page-wrapper" v-if="!loading && total > 9">
						<div class="page-wrapper-left">
							<div>共{{total}}条数据，当前第{{page}}页</div>
							<div style="margin-left: 5px">
								<DropDown :content="rowsShow" :items="rowsData" v-on:sendInfo="rowsInfo"
									class="DropDown"></DropDown>
							</div>
						</div>
						<div class="page-wrapper-right">
							<div class="page-btn" @click="firstPage">首页</div>
							<div class="page-btn" @click="previousPage">上一页</div>
							<div class="page-btn" @click="nextPage">下一页</div>
							<div class="page-btn" @click="lastPage">尾页</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition name="fade">
			<div class="alert-box" v-if="contrastShowBox" @click="contrastShowBox = 0">
				<div class="alert-content" style="width: 45vw">
					<div class="alert-content-title">数据对比</div>
					<div class="alert-content-msg" style="justify-content: space-around;width: 90%">
						<div class="top-crib-title" v-for="(data,index) in contrastList" :key="index">
							<div>垛位号：{{data.stack? data.stack:'--'}}</div>
							<div>当前湿度：{{data.val? data.val:'--'}}</div>
							<div>最大湿度：{{data.maxVal? data.maxVal:'--'}}</div>
							<div>最小湿度：{{data.minVal? data.minVal:'--'}}</div>
							<div>平均湿度：{{data.avgVal? data.avgVal:'--'}}</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import DropDown from '../../../components/DropDownSingle'
	import {
		searchDataReport,
		warehouseNode
	} from '../../../api/basic'
	import {
		getDate,
		renderTime
	} from '../../../tools/methods'
import localforage from 'localforage'
	export default {
		name: 'MoistureSensor',
		components: {
			DropDown
		},
		data() {
			return {
				time: [getDate(false), getDate(true)],
				nodeType: '05',
				nodeName: '无线包芯水分传感器',
				tableData: [],
				warehouse: [],
				building: [],
				floor: [],
				area: [],
				stack: [],
				warehouseTitle: '请选择仓库',
				buildingTitle: '请选择楼号',
				floorTitle: '请选择层号',
				areaTitle: '请选择区号',
				stackTitle: '请选择垛位',
				siteId: '',
				siteType: '',
				loading: false,
				all: false,
				page: '1',
				rows: '9',
				total: '',
				rowsShow: '9 条/页',
				rowsData: [{
						name: '9 条/页',
						value: 9
					},
					{
						name: '20 条/页',
						value: 20
					},
					{
						name: '100 条/页',
						value: 100
					},
					{
						name: '200 条/页',
						value: 200
					}
				],
				idList: [],
				excelData: {},
				storehouseFlag: false,
				contrastList: [],
				contrast1: '请选择对比数据',
				contrast2: '请选择对比数据',
				contrastShowBox: 0,
				contrast1show: 0,
				contrast2show: 0,
				// 养护阶段数据
				maintainStageData: [{
						name: "全部",
						value: ""
					},
					{
						name: "自然醇化阶段",
						value: "01"
					},
					{
						name: "防霉杀虫阶段",
						value: "02"
					},
					{
						name: "气调醇化阶段",
						value: "03"
					},
					{
						name: "气调保质阶段",
						value: "04"
					},
				],
				maintainStage: "",
				maintainStageName: "请选择养护阶段",
			}
		},
		created() {
			let body = {
				warehouseNodeId: '',
				warehouseNodeType: '01'
			}
			warehouseNode(body).then(res => {
				console.log(res)
				this.warehouse = res.data
			}).catch(err => {
				console.log(err)
			})
			let _this = this
			localforage.getItem('bodyRepotMoi').then(res => {
				if (res) {
					this.page = res.page;
					this.rows = res.rows;
					this.nodeType = res.nodeType;
					this.siteId = res.siteId;
					this.siteType = res.siteType;
					switch (res.maintainStage) {
						case '01':
							this.maintainStageName = "自然醇化阶段"
							break;
						case "02":
							this.maintainStageName = "防霉杀虫阶段"
							break;
						case "03":
							this.maintainStageName = "气调醇化阶段"
							break;
						case "04":
							this.maintainStageName = "气调保质阶段"
							break;
						case '':
							this.maintainStageName = "请选择养护阶段"
							break;
					}
					this.maintainStage = res.maintainStage;
					this.time = [res.startDate, res.endDate]
					this.storehouseFlag = res.storehouseFlag,
						this.warehouseTitle = res.warehouseTitle
					this.buildingTitle = res.buildingTitle
					this.floorTitle = res.floorTitle
					this.areaTitle = res.areaTitle
					this.stackTitle = res.stackTitle
					// console.log(res)
					_this.handleSearch();
				} else {
					_this.handleSearch();
				}
			})
		},
		methods: {
			// 选择养护阶段
			showInfoMaintainStag: function(data) {
				this.maintainStage = data.value;
				this.maintainStageName = data.name;
			},
			toOxygenSensor: function() {
				this.$router.push({
					path: '/report',
					query: {
						index: '11'
					}
				})
			},
			toTemperatureAndHumiditySensor: function() {
				this.$router.push({
					path: '/report/TemperatureAndHumiditySensor',
					query: {
						index: '11'
					}
				})
			},
			toTemperatureSensor: function() {
				this.$router.push({
					path: '/report/TemperatureSensor',
					query: {
						index: '11'
					}
				})
			},
			toCarbonDioxideSensor: function() {
				this.$router.push({
					path: '/report/CarbonDioxideSensor',
					query: {
						index: '11'
					}
				})
			},
			toTypeStatistics: function() {
				this.$router.push({
					path: '/report/TypeStatistics',
					query: {
						index: '11'
					}
				})
			},
			// 格式化时间
			getTime: function(time) {
				return renderTime(time)
			},

			// 选择仓库
			showInfoW: function(data) {
				this.warehouseTitle = data.name
				this.siteId = data.id
				this.siteType = data.siteType
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: '02'
				}
				warehouseNode(body).then(res => {
					console.log(res)
					this.building = res.data
					this.buildingTitle = '请选择楼号'
					this.floor = []
					this.floorTitle = '请选择层号'
					this.area = []
					this.areaTitle = '请选择区号'
					this.stack = []
					this.stackTitle = '请选择垛位'
				}).catch(err => {
					console.log(err)
				})
			},
			// 选择楼号
			showInfoB: function(data) {
				this.buildingTitle = data.name
				this.siteId = data.id
				this.siteType = data.siteType
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: '03'
				}
				warehouseNode(body).then(res => {
					console.log(res)
					this.floor = res.data
					this.floorTitle = '请选择层号'
					this.area = []
					this.areaTitle = '请选择区号'
					this.stack = []
					this.stackTitle = '请选择垛位'
				}).catch(err => {
					console.log(err)
				})
			},
			// 选择层号
			showInfoF: function(data) {
				this.floorTitle = data.name
				this.siteId = data.id
				this.siteType = data.siteType
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: '04'
				}
				warehouseNode(body).then(res => {
					console.log(res)
					this.area = res.data
					this.areaTitle = '请选择区号'
					this.stack = []
					this.stackTitle = '请选择垛位'
				}).catch(err => {
					console.log(err)
				})
			},
			// 选择区号
			showInfoA: function(data) {
				this.areaTitle = data.name
				this.siteId = data.id
				this.siteType = data.siteType
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: '05'
				}
				warehouseNode(body).then(res => {
					console.log(res)
					this.stack = res.data
					this.stackTitle = '请选择垛位'
				}).catch(err => {
					console.log(err)
				})
			},
			// 选择垛位
			showInfoS: function(data) {
				console.log(data)
				this.stackTitle = data.name
				this.siteId = data.id
				this.siteType = data.siteType
			},
			// 查询数据报表
			handleSearch: function() {
				this.loading = true
				this.tableData = []
				this.all = false
				this.idList = []
				let body = {
					page: this.page,
					rows: this.rows,
					nodeType: this.nodeType,
					siteId: this.siteId,
					maintainStage: this.maintainStage,
					siteType: this.siteType,
					startDate: this.time ? this.time[0] : '',
					endDate: this.time ? this.time[1] : '',
					storehouseFlag: this.storehouseFlag,
					warehouseTitle: this.warehouseTitle,
					buildingTitle: this.buildingTitle,
					floorTitle: this.floorTitle,
					areaTitle: this.areaTitle,
					stackTitle: this.stackTitle,
				}
				console.log(body)
				searchDataReport(body).then(res => {
					console.log(res)
					localforage.setItem('bodyRepotMoi', body)
					res.data.rows && res.data.rows.map(item => {
						item.sign = 0
						item.grey = 0
						if (this.contrastList.length === 2) {
							if (this.contrastList[0].nodeId === item.nodeId || this.contrastList[1]
								.nodeId === item.nodeId) {
								item.grey = 1
							}
						} else if (this.contrastList.length === 1) {
							if (this.contrastList[0].nodeId === item.nodeId) {
								item.grey = 1
							}
						}
					})
					this.tableData = res.data.rows
					this.total = res.data.total
					console.log(this.tableData)
					this.loading = false
				}).catch(err => {
					console.log(err)
					this.loading = false
				})
			},
			firstPage: function() {
				console.log('首页')
				if (this.page === 1) {
					this.$message({
						message: '当前为第一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					this.page = 1
					this.handleSearch()
				}
			},
			previousPage: function() {
				console.log('上一页')
				if (this.page < 2) {
					this.$message({
						message: '当前为第一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					this.page--
					this.handleSearch()
				}
			},
			nextPage: function() {
				console.log('下一页')
				if (parseInt(this.total / this.rows) + 1 > this.page) {
					this.page++
					this.handleSearch()
				} else {
					this.$message({
						message: '当前为最后一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				}
			},
			lastPage: function() {
				console.log('尾页')
				if (this.page === parseInt(this.total / this.rows) + 1) {
					this.$message({
						message: '当前为最后一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					if (Math.round(this.total % this.rows) === 0) {
						this.page = parseInt(this.total / this.rows)
					} else {
						this.page = parseInt(this.total / this.rows) + 1
					}
					this.handleSearch()
				}
			},
			rowsInfo: function(data) {
				console.log(data)
				this.rows = data.value
				this.rowsShow = data.name
				this.page = 1
				this.handleSearch()
			},
			selectAll: function() {
				this.all = !this.all
				let idList = []
				if (this.all) {
					this.tableData.map((data, index) => {
						data.sign = 1
						idList.push(data)
					})
					this.idList = idList
				} else {
					this.tableData.map((data, index) => {
						data.sign = 0
						this.idList = []
					})
				}
				console.log(this.idList)
			},
			selectSingle: function(body) {
				this.tableData.map((data, index) => {
					if (body === data) {
						data.sign = data.sign === 1 ? 0 : 1
						if (data.sign === 1) {
							this.idList.push(data)
						} else {
							let idList = []
							this.idList.map((item, index) => {
								if (item !== body) {
									idList.push(item)
								}
							})
							this.idList = idList
						}
						console.log(this.idList)
					}
				})
				this.all = this.idList.length === this.tableData.length
				console.log(this.idList)
			},
			// 导出表格数据处理
			downloadDatarReport() {
				if (!this.idList[0]) {
					this.$message({
						message: '请选择要导出的数据',
						type: 'warning'
					})
				} else {
					console.log(this.tableData)
					const tHeader = ['垛位号', '烟叶代码', '烟叶名称', '养护阶段', '当前湿度', '最大湿度', '最小湿度', '平均湿度', '时间']
					const filterVal = ['stack', 'materialCode', 'materialName', 'maintainStage', 'val', 'maxVal', 'minVal',
						'avgVal', 'createdTime'
					]
					const list = this.idList.map(item => {
						return {
							stack: item.stack,
							materialCode: item.materialCode,
							materialName: item.materialName,
							maintainStage: item.maintainStage ? item.maintainStage.name : '',
							val: item.val,
							maxVal: item.maxVal,
							minVal: item.minVal,
							avgVal: item.avgVal,
							createdTime: this.getTime(item.createdTime)
						}
					})
					this.excelData = {
						tHeader: tHeader,
						filterVal: filterVal,
						list: list,
						name: this.nodeName
					}
					console.log(this.excelData)
					this.export2Excel(this.excelData)
				}
			},
			export2Excel: function(body) {
				require.ensure([], () => {
					const {
						exportJson
					} = require('../../../vendor/Export2Excel')
					const tHeader = body.tHeader
					const filterVal = body.filterVal
					const list = body.list
					const data = this.formatJson(filterVal, list)
					exportJson(tHeader, data, body.name + '--数据报表')
				})
				this.$message({
					message: '导出数据成功',
					type: 'success'
				})
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			addContrast: function(data) {
				console.log(this.contrastList)
				if (this.contrastList.length < 2) {
					data.grey = 1
					this.contrastList.push(data)
					this.contrastjudge()
				} else {
					this.$message({
						message: '最多选择两条数据',
						type: 'warning'
					})
				}
			},
			delContrast: function(index) {
				this.tableData.map(item => {
					if (this.contrastList[index].nodeId === item.nodeId) {
						item.grey = 0
					}
				})
				this.contrastList.splice(index, 1)
				this.contrastjudge()
				console.log(this.contrastList)
			},
			contrastjudge: function() {
				if (this.contrastList.length === 2) {
					this.contrast1 = this.contrastList[0].stack ? this.contrastList[0].stack : '--'
					this.contrast2 = this.contrastList[1].stack ? this.contrastList[1].stack : '--'
					this.contrast1show = this.contrast2show = 1
				} else if (this.contrastList.length === 1) {
					this.contrast1 = this.contrastList[0].stack ? this.contrastList[0].stack : '--'
					this.contrast2 = '请选择对比数据'
					this.contrast1show = 1
					this.contrast2show = 0
				} else {
					this.contrast1 = '请选择对比数据'
					this.contrast2 = '请选择对比数据'
					this.contrast1show = this.contrast2show = 0
				}
			},
			contrastShow: function() {
				if (this.contrastList.length === 2) {
					this.contrastShowBox = 1
				} else {
					this.$message({
						message: '请选择两条数据',
						type: 'warning'
					})
				}
			}
		}
	}
</script>

<style scoped>
	@import "Report.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/report/MoistureSensor.vue